<ng-container *transloco="let t" class="container">
  <div class="p-2">
    <div class="modal-header">
      <h5 class="modal-title">{{ title }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="onDismissClick()">
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="inputForm">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="modal-subtitle">
              {{ t('account.statements.registration') }}
            </div>
            <div class="py-4">
              <span class="fw-bold">{{ t('account.statements.amount.registrationId') }}: </span>
              {{ raceRegistration?.id ?? '' }}
              @if (raceRegistration!.events && raceRegistration!.race) {
                <div>
                  <span class="fw-bold">{{ t('race.details.event.name') }}: </span>
                  <app-language-output [hrLabel]="raceRegistration?.events?.name"
                                       [enLabel]="raceRegistration?.events?.nameEng"
                                       [itLabel]="raceRegistration?.events?.nameIta"
                                       [siLabel]="raceRegistration?.events?.nameSlo"
                                       [srLabel]="raceRegistration?.events?.nameSr"
                                       [bsLabel]="raceRegistration?.events?.nameBs"
                                       [defaultLanguage]="raceRegistration?.events?.defaultLanguage"
                                       [languages]="languages"/>
                </div>
                <div>
                  <span class="fw-bold">{{ t('app.common.race') }}: </span>
                  <app-language-output [hrLabel]="raceRegistration?.race?.name"
                                       [enLabel]="raceRegistration?.race?.nameEng"
                                       [itLabel]="raceRegistration?.race?.nameIta"
                                       [siLabel]="raceRegistration?.race?.nameSlo"
                                       [srLabel]="raceRegistration?.race?.nameSr"
                                       [bsLabel]="raceRegistration?.race?.nameBs"
                                       [defaultLanguage]="raceRegistration?.events?.defaultLanguage"
                                       [languages]="languages"/>
                </div>
              }
              <!--              <span class="fw-bold">
                              {{ t('account.statements.registration.status') }}:
                            </span>
                            <span>{{ raceRegistration?.paymentStatus ?? '' }}</span>-->
              <div>
                <span class="fw-bold">
                {{ t('account.statements.type.of.registration') }}:
              </span>
                <span>{{ raceRegistration| registrationTypeName |uppercase }}</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="modal-subtitle">
              {{ t('account.statements.payment.order') }}
            </div>
            <div class="py-4">
              <span class="fw-bold">{{ t('account.statements.order.id') }}: </span>
              <span>{{ raceRegistration?.order?.id ?? "" }}</span>
              <div>
                <span class="fw-bold">{{ t('account.statements.total.price') }}: </span>
                <span>
                  {{ raceRegistration?.order?.totalPrice ? (raceRegistration!.order!.totalPrice |myCurrency) : "-" }}
                </span>
              </div>
              <div>
                <span class="fw-bold">{{ t('account.statements.total.price.with.discount') }}: </span>
                <span>
                  {{
                    raceRegistration?.order?.totalPriceWithDiscount
                      ? (raceRegistration!.order!.totalPriceWithDiscount |myCurrency) : "-"
                  }}
                </span>
              </div>
              <div>
                <span class="fw-bold">{{ t('account.statements.payer.desc.reference') }}: </span>
                <span>{{ (raceRegistration?.order?.paymentDesc ?? '-') }}</span>
              </div>
              <div>
                <span class="fw-bold">{{ t('account.statements.payment.status') }}: </span>
                <span>{{
                    ((raceRegistration?.order?.amountStatus !== undefined && raceRegistration?.order?.amountStatus !== null)? t("account.statements.amountStatus." +
                      raceRegistration!.order!.amountStatus) : "-")
                  }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="pb-2">
          <div class="table-responsive">
            <table class="table table-last-row-no-border">
              <thead>
              <tr>
                <th scope="col">{{ t('competitor.table.first.name') }}</th>
                <th scope="col">{{ t('competitor.table.last.name') }}</th>
                <th scope="col">{{ t('competitor.table.email') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let competitor of raceRegistration?.competitors">
                <td class="center-align">
                  {{
                    ((competitor?.firstName ?? "-")| titlecase)
                  }}
                </td>
                <td class="center-align">
                  {{
                    ((competitor?.lastName ?? "-") |
                      titlecase)
                  }}
                </td>
                <td class="center-align">
                  {{
                    ((competitor?.email ?? "-"))
                  }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-xl-6">
            <app-input formControlName="statementId" label="account.statements.statement.id"/>
          </div>
          <div class="col-12 col-xl-6">
            <app-input formControlName="statementDesc" label="account.statements.description"/>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <div class="d-flex justify-content-end">
        <div class="me-3">
          <app-button (onClick)="onDismissClick()" [label]="dismissButtonTitle ?? t('app.common.cancel')"
                      [btnClass]="'btn-grey text-uppercase'"></app-button>
        </div>
        <app-button (onClick)="onConfirmClick()"
                    [isDisabled]="!inputForm.valid"
                    [label]="confirmButtonTitle ?? t('account.statements.confirm.statement')"
                    [btnClass]="'btn-primary-red text-uppercase'"></app-button>
      </div>
    </div>
  </div>
</ng-container>
